__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "portalHost";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@okta/okta-react", "3.0.7", () => (Promise.all([__webpack_require__.e(6835), __webpack_require__.e(8816)]).then(() => (() => (__webpack_require__(96835))))));
			register("@playgami/portal-logs", "1.5.0", () => (__webpack_require__.e(9657).then(() => (() => (__webpack_require__(89657))))));
			register("lodash", "4.17.23", () => (__webpack_require__.e(9680).then(() => (() => (__webpack_require__(49680))))));
			register("react-dom", "18.3.1", () => (() => (__webpack_require__(70316))), 1);
			register("react-redux", "9.2.0", () => (__webpack_require__.e(3828).then(() => (() => (__webpack_require__(3828))))));
			register("react-router-dom", "5.3.4", () => (__webpack_require__.e(17).then(() => (() => (__webpack_require__(10017))))));
			register("react", "18.3.1", () => (() => (__webpack_require__(22155))), 1);
			register("redux", "5.0.1", () => (() => (__webpack_require__(90805))), 1);
			initExternal(19034);
			initExternal(95793);
			initExternal(37290);
			initExternal(36878);
			initExternal(28235);
			initExternal(43996);
			initExternal(12084);
			initExternal(66474);
			initExternal(5394);
			initExternal(73577);
			initExternal(93543);
			initExternal(47276);
			initExternal(88799);
			initExternal(50085);
			initExternal(35055);
			initExternal(16742);
			initExternal(98412);
			initExternal(40672);
			initExternal(12851);
			initExternal(25725);
			initExternal(66615);
			initExternal(1684);
			initExternal(98104);
			initExternal(57158);
			initExternal(75778);
			initExternal(12201);
			initExternal(4551);
			initExternal(49099);
			initExternal(19183);
			initExternal(37558);
			initExternal(20501);
			initExternal(48940);
			initExternal(42959);
			initExternal(51274);
			initExternal(50986);
			initExternal(56671);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};